module.exports = __webpack_public_path__ + "img/吻.c5f397cf.gif";